module.exports = __webpack_public_path__ + "static/media/Right legs22.6aada8de.png";